export const iconFontAwesomeMusicVideoMicrophoneLinesSlash = (
	<i className="fa-solid fa-microphone-lines-slash"></i>
);
